export enum E2eTestScenario {
  WorkspaceCreate = 'workspace-create',
  WorkspaceMetadataEdit = 'workspace-metadata-edit',
  WorkspaceParticipantsManagement = 'workspace-participants-management',
}
